export default __webpack_public_path__ + "static/media/Scissor.4d3af62c.png";